export const delay = async (milliseconds: number): Promise<boolean> => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
